import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): [T] {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(t);
  }, [value, delayMs]);
  return [debounced];
}
